<header>
    <mat-toolbar>
        <!-- <span class="title-pral" i18n [innerHTML]="title"></span> -->
        <img class="logo" src="assets/images/Logo Alumni fondo blanco.jpg" alt="Logo Alumnis CMAB" />
        <span class="spacer"></span>
        <div class="lang-info">
            <span i18n="@@idioma">Idioma</span>: {{locale_id}}
        </div>
        @if (isLogged) {
            <div class="app-menu">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button class="app-menu" mat-menu-item (click)='logout()'>
                        <mat-icon>logout</mat-icon>
                        <span i18n>Cerrar sesión</span>
                    </button>
                    <hr />  
                    <button class="app-menu" mat-menu-item (click)='about()'>
                        <mat-icon>contact_support</mat-icon>
                        <span i18n>Acerca de</span>
                    </button>
                </mat-menu>
            </div>
        }
    </mat-toolbar>
</header>
<main>
    <router-outlet></router-outlet>
</main>
<footer>
    <p class="copyright">
        &copy; Petrasoft.es - 2026
    </p>
</footer>